export default __webpack_public_path__ + "static/media/logo_uin.79e92a68.png";